import OnboardingTour from '../../../../shared/onboarding/OnboardingTour';
import React from 'react';


export default function ValidateDetailsFieldsTour() {
  return (
    <OnboardingTour
      tourId="ValidateDetailsFields"
      steps={[
        {
          selector: '[data-key="detail-boxes-list"]',
          content: 'Click on the detail box value to edit or update it as needed.',
        },
        {
          selector: '[data-key="selected-fields-counter"]',
          content: 'Use the checkboxes below to mark the fields you have already verified. ' +
            'This will help ensure all details are reviewed and accurate.',
        }
      ]}
    />
  );
}
